import { useQuery } from '@tanstack/react-query';
import type { Variables } from 'graphql-request';
import { useSelector } from 'react-redux';
import { gqlClient } from 'src/client/gql-client';
import { usePageMetaTags } from 'src/hooks/use-page-meta-tags';
import { useRouteLoaded } from 'src/hooks/use-route-loaded';
import type { AppState } from 'src/reducers';
import type { Campaign } from 'src/types';

type PageQueryOptions = {
  query: string;
  routeName: string;
  variables?: Variables;
};

export function usePageQuery<T>(options: PageQueryOptions) {
  const { routeName, query } = options;

  const activeCampaign = useSelector<AppState, Campaign>(state =>
    state.globals.campaigns.active.find((c: Campaign) => c.type === 'OFFER')
  );

  const variables = {
    ...options.variables,
    campaignId: activeCampaign?.id,
  };

  const result = useQuery({
    queryKey: [routeName, 'page', variables],
    queryFn: () => gqlClient.request<T>(query, variables),
    useErrorBoundary: true,
  });

  useRouteLoaded(result.data);
  usePageMetaTags(result.data);

  return result;
}
